'use client';

import React, { useEffect } from 'react';
import { useProfile } from 'src/context/providers/ProfileProvider';
import useGetPublications from 'src/hooks/publications/useGetPublications';
import { CircularProgress, EmptyState } from 'src/components';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faBook } from '@fortawesome/pro-solid-svg-icons';
import { PublicationItem } from './components';

const Publications = () => {
  const { entityDetails } = useProfile();

  useEffect(() => {
    const appContainer = document.querySelector('#app-container');
    if (appContainer) {
      appContainer.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [entityDetails?.provider_id]);

  const { data: publications, isLoading: isLoadingPublications } =
    useGetPublications({ providerId: entityDetails?.provider_id });

  const renderContent = () => {
    if (isLoadingPublications) {
      return (
        <div
          className="border border-neutral-100 p-4 bg-neutral-50 rounded-lg"
          data-testid="empty-state-container"
        >
          <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
            <div className="flex flex-col items-center gap-4">
              <CircularProgress
                size="lg"
                color="neutral"
                data-testid="loading-spinner"
              />
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="flex flex-col p-4">
          <h1 className="text-2xl font-bold text-neutral-600 pb-4">
            Publications
          </h1>
          {publications?.results?.map((publication) => (
            <PublicationItem key={publication.id} publication={publication} />
          ))}
        </div>
      );
    }
  };
  const isEmpty = !isLoadingPublications && publications?.results?.length === 0;

  return (
    <div className="flex flex-col gap-4 max-w-[1200px] mx-auto">
      <div className="flex flex-col gap-2">
        {isEmpty ? (
          <EmptyState
            title="No Publications Available"
            description="This provider doesn't have any publications to display."
            icon={<Icon icon={faBook} className="text-6xl text-neutral-400" />}
          />
        ) : (
          renderContent()
        )}
      </div>
    </div>
  );
};

export default Publications;
